var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ik-data-table',{attrs:{"entity-name":_vm.$t('FreeInformationBon'),"icon":'mdi-format-list-bulleted',"model":_vm.model,"use-select":true}})
}
var staticRenderFns = []

export { render, staticRenderFns }